var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkResizeIconHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_158_4164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.1768,
    width: 20,
    height: 20,
    transform: "rotate(-180 20 20.1768)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_158_4164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 7.67676V9.34342L3.33342 9.34342V7.67676L16.6667 7.67676ZM16.6667 11.0101V12.6768L3.33342 12.6768V11.0101L16.6667 11.0101Z",
    fill: "#ADB5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkResizeIconHorizontal);
export default __webpack_public_path__ + "static/media/bookmark_resize_icon_horizontal.89ddff9accb545d1920455736eff61a5.svg";
export { ForwardRef as ReactComponent };